var t = Object.defineProperty;
var c = (r, n, s) => n in r ? t(r, n, { enumerable: !0, configurable: !0, writable: !0, value: s }) : r[n] = s;
var a = (r, n, s) => (c(r, typeof n != "symbol" ? n + "" : n, s), s);
var u = /* @__PURE__ */ ((r) => (r.Error = "error", r.Warning = "warning", r.Info = "info", r.Success = "success", r))(u || {});
const e = (r) => r !== null && typeof r == "object" && "data" in r, o = (r) => r !== null && typeof r == "object" && "error" in r;
class E extends Error {
  constructor(s) {
    super(s == null ? void 0 : s.message);
    a(this, "apiError");
    this.name = "NylasAPIError", this.stack = new Error().stack, this.apiError = s;
  }
}
export {
  u as NotificationType,
  E as NylasAPIError,
  o as isNylasErrorResponse,
  e as isNylasSuccessResponse
};
